import { useContext, useState, useEffect } from 'react';
import { PlayerTimeContext, usePlayerCurrentTime, usePlayerTime } from '@dtvgo/player-context';
import { ScheduleContext } from './contexts.js';

const DELAYED_SECONDS = 5;
function isDelayed(timeShift) {
  return Math.abs(timeShift) > DELAYED_SECONDS;
}
function useIsDelayed(isLive = true) {
  const timeShiftValueStore = useContext(PlayerTimeContext);
  const [delayed, setDelayed] = useState(isLive && isDelayed(timeShiftValueStore.get()));
  useEffect(() => isLive ? timeShiftValueStore.onChange((timeShift) => {
    setDelayed(isDelayed(timeShift));
  }) : void 0, [isLive, timeShiftValueStore]);
  return delayed;
}
function useLiveDuration() {
  const { startTime, endTime } = useContext(ScheduleContext);
  return (endTime - startTime) / 1e3;
}
function useLiveEdgeProgress() {
  const { startTime } = useContext(ScheduleContext);
  const currentTime = usePlayerCurrentTime();
  return currentTime - startTime / 1e3;
}
function useLiveProgress() {
  const liveEdgeProgress = useLiveEdgeProgress();
  const timeShift = usePlayerTime();
  return liveEdgeProgress + timeShift;
}

export { useIsDelayed, useLiveDuration, useLiveEdgeProgress, useLiveProgress };
//# sourceMappingURL=hooks.js.map
